module.exports = __webpack_public_path__ + "media/images/appIcon-af5dafd04f6357a2841ea10a486d49ff.png";